import { createQueryKeys } from "@lukemorales/query-key-factory";
import { useQuery } from "@tanstack/vue-query";
import axios from "axios";
import { ProductsApi } from "mws-ts-v2-sdk";

let productsApi: ProductsApi;
const getProductsApi = () => {
  // reduce memory overhead by only using one instance
  if (!productsApi) {
    productsApi = new ProductsApi(
      undefined,
      useRuntimeConfig().public.catalogServiceUrl,
      axios,
    );
  }

  return productsApi;
};

export const matchScoredBallsQueryKey = createQueryKeys("matchScoredBalls", {
  matchScoredBalls: (
    categoryId: MaybeRef<string>,
    params: {
      numberOfProducts: MaybeRef<number>;
      platformId: MaybeRef<string>;
    },
  ) => ({
    queryKey: [categoryId, params.numberOfProducts],
    queryFn: async () => {
      const response =
        await getProductsApi().v2ProductsMatchScoredBallsCategoryCategoryIdGet({
          categoryId: unref(categoryId),
          xPlatformKey: unref(params.platformId),
          numberOfProducts: unref(params.numberOfProducts),
        });

      return response.data;
    },
  }),
});

export const useMatchScoredBallsQuery = (categoryId: Ref<string>) => {
  const platformStore = usePlatformStore();
  const platformId = computed(
    () => platformStore.getPlatformConfiguration.platformId,
  );

  return useQuery({
    ...matchScoredBallsQueryKey.matchScoredBalls(categoryId, {
      numberOfProducts: 4,
      platformId,
    }),
    refetchInterval: (query) => {
      const shouldRefetch = query.state.data?.showMatchScoredBalls;

      return shouldRefetch ? 60000 : false; // refetch every minute - 60000ms
    },
  });
};
